import { BreadcrumbsHeader } from 'components/molecules/BreadcrumbsHeader';
import { useRouteMatch } from 'react-router-dom';
import { Grid } from '@mui/material';
import { ReportList } from 'components/organisms/Report/ReportList';

export const Report = () => {
  const { path } = useRouteMatch();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} mb={1}>
        <BreadcrumbsHeader items={[{ title: 'Relatório' }]} />
      </Grid>
      <Grid item xs={12}>
        <ReportList />
      </Grid>
    </Grid>
  );
};
